import { licenseModule } from '@/store/license/module'
import { organizationModule } from '@/store/organization/module'
import { isPromise } from '@/utils'
import type { Study } from '@pocketprep/types'
import { examModule } from '../exam/module'
import { computed } from 'vue'

const getCurrentOrgLicenses = () => {
    const currentOrganization = organizationModule.getters.getCurrentOrganization()
    const currentOrgLicenses = currentOrganization
        && licenseModule.state.currentOrgLicenses[currentOrganization.objectId]?.value

    if (currentOrgLicenses && !(isPromise(currentOrgLicenses))) {
        return currentOrgLicenses
    } else {
        return []
    }
}

const studentLicenseLib = computed(() => {
    const currentOrganization = organizationModule.getters.getCurrentOrganization()
    const currentOrgLicenses = currentOrganization
        && licenseModule.state.currentOrgLicenses[currentOrganization.objectId]?.value

    if (!currentOrgLicenses || isPromise(currentOrgLicenses)) {
        return {}
    }
    return currentOrgLicenses.reduce<{ [studentId: string]: Study.Class.LicenseJSON[] }>((acc, l) => {
        if (!l.orgStudent) {
            return acc
        }
        if (!(l.orgStudent.objectId in acc)) {
            acc[l.orgStudent.objectId] = []
        }
        acc[l.orgStudent.objectId]?.push(l)
        return acc
    }, {})
})

const getStudentLicenseLib = () => {
    return studentLicenseLib.value
}

const examGuidAvailableLicenseLib = computed(() => {
    const currentOrgExams = examModule.getters.getCurrentOrgExams()
    const examMetadata = examModule.getters.getExamMetadata()
    const currentOrgLicenses = licenseModule.getters.getCurrentOrgLicenses()
    const exams = Object.values(currentOrgExams).reduce((acc, exam) => {
        const em = exam && examMetadata[exam.examMetadata.objectId]
        const examGuid = em && em.examGuid
        if (!examGuid) {
            return acc
        }
        acc[examGuid] = 0
        return acc
    }, {} as { [examGuid: string]: number })

    return currentOrgLicenses.reduce((acc, l) => {
        if (!l.examGuid) {
            return acc
        }
        if (l.status === 'available') {
            acc[l.examGuid] = (acc[l.examGuid] ?? 0) + 1
        }
        return acc
    }, exams as { [examGuid: string]: number })
})

const getExamGuidAvailableLicenseLib = () => {
    return examGuidAvailableLicenseLib.value
}

const getLicensesForStudentId = (studentId: string) => {
    return getStudentLicenseLib()[studentId]
}

export default {
    getCurrentOrgLicenses,
    getStudentLicenseLib,
    getExamGuidAvailableLicenseLib,
    getLicensesForStudentId,
}
